import notesApi from '@/api/notes';

const state = {
    listNotes: null,
    notesCreated: null,
    notesUpdated: null,
    notesRemoved: null,
    isLoading: false,
    validationErrors: null,
}

export const mutationTypes = {
    getNotesListStart: '[notesList] Get notes list start',
    getNotesListSuccess: '[notesList] Get notes list success',
    getNotesListFailure: '[notesList] Get notes list failure',

    notesAddStart: '[notes] Create notes start',
    notesAddSuccess: '[notes] Create notes success',
    notesAddFailure: '[notes] Create notes failure',

    notesEditStart: '[notes] Update notes start',
    notesEditSuccess: '[notes] Update notes success',
    notesEditFailure: '[notes] Update notes failure',

    notesRemoveStart: '[notes] Remove notes start',
    notesRemoveSuccess: '[notes] Remove notes success',
    notesRemoveFailure: '[notes] Remove notes failure',
}

export const notesActionTypes = {
    getNotesList: '[notesList] Get notes list',
    notesAdd: '[notes] Create notes',
    notesEdit: '[notes] Update notes',
    notesRemove: '[notes] Remove notes'
}

const mutations = {
    [mutationTypes.getNotesListStart](state) {
        state.isLoading = true
        state.listNotes = null
    },
    [mutationTypes.getNotesListSuccess](state, payload) {
        state.isLoading = false
        state.listNotes = payload
        state.validationErrors = null
    },
    [mutationTypes.getNotesListFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.notesAddStart](state) {
        state.isLoading = true
        state.notesCreated = null
    },
    [mutationTypes.notesAddSuccess](state, payload) {
        state.isLoading = false
        state.notesCreated = payload
        state.validationErrors = null
    },
    [mutationTypes.notesAddFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.notesEditStart](state) {
        state.isLoading = true
        state.notesUpdated = null
    },
    [mutationTypes.notesEditSuccess](state, payload) {
        state.isLoading = false
        state.notesUpdated = payload
        state.validationErrors = null
    },
    [mutationTypes.notesEditFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    },

    [mutationTypes.notesRemoveStart](state) {
        state.isLoading = true
        state.notesRemoved = null
    },
    [mutationTypes.notesRemoveSuccess](state, payload) {
        state.isLoading = false
        state.notesRemoved = payload
        state.validationErrors = null
    },
    [mutationTypes.notesRemoveFailure](state,payload) {
        state.isLoading = false
        state.validationErrors = payload
    }
}

const actions = {
    [notesActionTypes.getNotesList](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.getNotesListStart)
            notesApi
                .getNotesList(data)
                .then(response => {
                    context.commit(mutationTypes.getNotesListSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.getNotesListFailure,response)
                })
        })
    },
    [notesActionTypes.notesAdd](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.notesAddStart)
            notesApi
                .notesAdd(data)
                .then(response => {
                    context.commit(mutationTypes.notesAddSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.notesAddFailure,response)
                })
        })
    },
    [notesActionTypes.notesEdit](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.notesEditStart)
            notesApi
                .notesEdit(data)
                .then(response => {
                    context.commit(mutationTypes.notesEditSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.notesEditFailure,response)
                })
        })
    },
    [notesActionTypes.notesRemove](context, data) {
        return new Promise(resolve => {
            context.commit(mutationTypes.notesRemoveStart)
            notesApi
                .notesRemove(data)
                .then(response => {
                    context.commit(mutationTypes.notesRemoveSuccess, response)
                    resolve(response)
                })
                .catch(response => {
                    context.commit(mutationTypes.notesRemoveFailure,response)
                })
        })
    }
}

export default {
    state,
    actions,
    mutations
}